import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/promote/pageContext';

export function ErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for Promote page (error: ${error})`);
}
